<footer class=" bg-themeBlackTwo xl:pt-[100px] xl:pb-7 pt-[80px] pb-9 relative text-gray-300 before:content-[''] before:h-8 before:w-full before:bg-white before:rounded-bl-[55px] before:rounded-br-[55px] before:absolute before:top-0 before:text-red-500 block text-sm font-medium hidden">
    <div class="mx-auto xl:px-[74px] px-5">
 
        <!-- TOP SECTION -->
        <div class="flex xl:flex-row flex-col justify-between items-start xl:gap-0 gap-8">
 
            <!-- Logo -->
            <a routerLink="/">
                <img src="../../../../../assets/theme/images/logo/footer-logo.svg" alt="logo white"
                    class="xl:mb-10 mb-0">
            </a>
 
            <!-- Nav Columns -->
            <div class="xl:flex xl:flex-row xl:justify-between xl:items-start xl:gap-[90px] grid grid-cols-2 gap-x-4 gap-y-8 w-full xl:w-auto">
 
                <!-- Categories Column — 50% on mobile, fixed on desktop -->
                <div class="col-span-1 xl:w-[198px]">
                    <ul class="space-y-3">
                        @for (item of categories; track $index) {
                        <li>
                            <a [routerLink]="getPackGalleryPath(item)"
                                class="sm:font-normal font-medium sm:text-base text-sm leading-5 sm:tracking-normal tracking-[-0.09px] hover:text-white cursor-pointer">
                                {{item.name}}
                            </a>
                        </li>
                        }
                    </ul>
                </div>
 
                <!-- Links Column — 50% on mobile, fixed on desktop -->
                <div class="col-span-1 xl:w-[198px]">
                    <ul class="space-y-3">
                        <li>
                            <a [routerLink]="['/designers']"
                                class="sm:font-normal font-medium sm:text-base text-sm leading-5 sm:tracking-normal tracking-[-0.09px] hover:text-white cursor-pointer">
                                Designers
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/pricing']"
                                class="sm:font-normal font-medium sm:text-base text-sm leading-5 sm:tracking-normal tracking-[-0.09px] hover:text-white cursor-pointer">
                                Plans and pricing
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/faq']"
                                class="sm:font-normal font-medium sm:text-base text-sm leading-5 sm:tracking-normal tracking-[-0.09px] hover:text-white cursor-pointer">
                                Faqs
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/contact-us']"
                                class="sm:font-normal font-medium sm:text-base text-sm leading-5 sm:tracking-normal tracking-[-0.09px] hover:text-white cursor-pointer">
                              Contact Us
                            </a>
                        </li>
                    </ul>
                </div>
 
                <!-- Get in Touch Column — full width on mobile, fixed on desktop -->
                <div class="col-span-2 xl:col-auto xl:w-[273px]">
                    <div>
                        <ul class="space-y-3">
                            <li>
                                <p class="font-medium text-base leading-normal text-white whitespace-nowrap">
                                    Get in touch
                                </p>
                            </li>
                            <li>
                                <p class="text-sm text-themeSuvaGreyo pr-5 font-semibold">
                                    Stay updated with our latest news and products
                                </p>
                            </li>
                            <!-- Social Icons -->
                            <li>
                                <div class="flex gap-2 mt-2">
                                    <a href="https://dribbble.com/creativestall" target="_blank" rel="noopener noreferrer"
                                        aria-label="Creative Stall on Dribbble"
                                        class="w-8 h-8 rounded-xl bg-[#FFFFFF0D] border border-[#FFFFFF1A] flex items-center justify-center">
                                        <img src="../../../../../assets/images/dribble-footer-icon.svg" alt="Creative Stall on Dribble" aria-hidden="true">
                                    </a>
                                    <a href="https://www.behance.net/creativestall" target="_blank" rel="noopener noreferrer"
                                        aria-label="Creative Stall on Behance"
                                        class="w-8 h-8 rounded-xl bg-[#FFFFFF0D] border border-[#FFFFFF1A] flex items-center justify-center">
                                        <img src="../../../../../assets/images/behance-footer-icon.svg" alt="Creative Stall on Behance" aria-hidden="true">
                                    </a>
                                    <a href="https://www.instagram.com/creative.stall/" target="_blank" rel="noopener noreferrer"
                                        aria-label="Creative Stall on Instagram"
                                        class="w-8 h-8 rounded-xl bg-[#FFFFFF0D] border border-[#FFFFFF1A] flex items-center justify-center">
                                        <img src="../../../../../assets/images/instagram-footer-icon.svg" alt="Creative Stall on Instagram" aria-hidden="true">
                                    </a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
 
            </div>
        </div>
 <div class="flex xl:flex-row flex-col justify-between items-start xl:gap-0 gap-8">
 
            <!-- Logo -->
            <a >
              
            </a>
 
            <!-- Nav Columns -->
            <div class="xl:flex xl:flex-row xl:justify-between xl:items-start xl:gap-[90px] grid grid-cols-2 gap-x-4 gap-y-8 w-full xl:w-auto">
 
                <!-- Categories Column — 50% on mobile, fixed on desktop -->
                 
                <!-- @if(eventCategories.length>0){

                    <div class="col-span-1 xl:w-[198px]">
                        <div class="mt-4 mb-2 font-medium text-base leading-normal hover:text-white">Calendar of Festivities</div>
                        <ul class="space-y-3">
                            @for (item of eventCategories; track $index) {
                            <li>
                                <a [routerLink]="getEventPackGalleryPath(item.eventName)"
                                    class="mt-2 sm:font-normal font-medium sm:text-base text-sm leading-5 sm:tracking-normal tracking-[-0.09px] hover:text-white cursor-pointer">
                                    {{item.eventName}}
                                </a>
                            </li>
                            }
                        </ul>
                    </div>
                } -->
 
                <!-- Links Column — 50% on mobile, fixed on desktop -->
                <div class="col-span-1 xl:w-[198px]">
                </div>
 
                <!-- Get in Touch Column — full width on mobile, fixed on desktop -->
                <div class="col-span-2 xl:col-auto xl:w-[273px]">
                    <div>
                    </div>
                </div>
 
            </div>
        </div>
        <!-- BOTTOM SECTION -->
        <div class="flex xl:flex-row flex-col justify-between items-start xl:items-center xl:gap-[90px] gap-6 xl:mt-36 mt-10">
 
            <!-- Copyright -->
            <div class="w-full xl:w-auto">
                <p class="text-sm font-medium text-themeSuvaGreyo whitespace-nowrap">
                    © {{currentYear}} Brickclay LLC. All rights reserved
                </p>
            </div>
 
            <!-- Bottom Links + Secure Payment -->
            <div class="flex xl:flex-row flex-col justify-between items-start xl:items-center xl:max-w-[848px] w-full gap-4">
 
                <!-- Terms / License / Privacy -->
                <div class="flex justify-start xl:justify-between sm:gap-4 gap-[30px] flex-wrap">
                    <div class="sm:w-[127px]">
                        <ul class="space-y-2">
                            <a [routerLink]="['/terms-of-use']"
                                class="text-sm font-medium text-themeSuvaGreyo">Terms</a>
                        </ul>
                    </div>
                    <div class="sm:w-[127px]">
                        <ul class="space-y-2">
                            <a [routerLink]="['/standard-commercial-license']"
                                class="text-sm font-medium text-themeSuvaGreyo">License</a>
                        </ul>
                    </div>
                    <div class="sm:w-[127px]">
                        <ul class="space-y-2">
                            <a [routerLink]="['/privacy-policy']"
                                class="text-sm font-medium text-themeSuvaGreyo">Privacy</a>
                        </ul>
                    </div>
                </div>
 
                <!-- Secure Payment Badge -->
                <div class="bg-[#FFFFFF0D] border border-[#FFFFFF1A] rounded-md px-3 py-2  inline-block pr-5">
                    <div class="flex items-center ">
                        <img src="../../../../../assets/theme/images/logo/secure-lock.svg" alt="secure lock">
                        <span class="text-xs leading-normal font-medium text-[#747474] ms-2 me-[14px]">Secure Payment</span>
                        <img src="../../../../../assets/theme/images/logo/stripe-logo.svg" width="66" height="28" alt="Stripe logo">
                    </div>
                </div>
 
            </div>
        </div>
 
    </div>
</footer>



<footer class="bg-themeBlackTwo xl:pt-[100px] xl:pb-7 pt-[80px] pb-9 relative text-gray-300 before:content-[''] before:h-8 before:w-full before:bg-white before:rounded-bl-[55px] before:rounded-br-[55px] before:absolute before:top-0 before:text-red-500 block text-sm font-medium before:mt-[-1px]">
    <div class="mx-auto lg:px-[104px] px-5">
 

<div class="grid grid-cols-12 xl:gap-x-4 gap-x-6 xl:gap-y-0 gap-y-9 xl:pb-[119px] pb-5">

  <!-- 1st = 4 cols -->
  <div class="xl:col-span-4 col-span-12">
    <a routerLink="/">
        <div class="flex justify-start items-center gap-4 mb-11 xl:mb-0">
            <img src="../../../../../assets/footer/footer-CS-logo.svg" alt="Creative Stall Logo" class="sm:size-[60px] size-[45px]">
            <div>
                <h2 class="font-bold xl:text-2xl text-lg leading-normal text-[#FFFFFF] mb-1">Creative Stall</h2>
                <p class="font-medium xl:text-base text-sm leading-5">A marketplace for creative assets</p>
            </div>
        </div>
            </a>
  </div>

  <!--2nd  = 2 cols -->
  <div class="xl:col-span-2 col-span-6">
             <ul class="xl:space-y-3  space-y-2.5">
                        @for (item of categories; track $index) {
                        <li>
                            <a [routerLink]="getPackGalleryPath(item)"
                                class="sm:font-normal font-medium sm:text-base text-sm leading-5 sm:tracking-normal tracking-[-0.09px] hover:text-white cursor-pointer">
                                {{item.name}}
                            </a>
                        </li>
                        }
                    </ul>
  </div>

  <!--3rd  = 2 cols -->
  <div class="xl:col-span-2 col-span-6">
      <ul class="xl:space-y-3  space-y-2.5">
                        <li>
                            <a [routerLink]="['/designers']"
                                class="sm:font-normal font-medium sm:text-base text-sm leading-5 sm:tracking-normal tracking-[-0.09px] hover:text-white cursor-pointer">
                                Designers
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/pricing']"
                                class="sm:font-normal font-medium sm:text-base text-sm leading-5 sm:tracking-normal tracking-[-0.09px] hover:text-white cursor-pointer">
                                Plans and pricing
                            </a>
                        </li>
                        <!-- <li>
                            <a [routerLink]="['/faq']"
                                class="sm:font-normal font-medium sm:text-base text-sm leading-5 sm:tracking-normal tracking-[-0.09px] hover:text-white cursor-pointer">
                                Faqs
                            </a>
                        </li> -->
                        <li>
                            <a [routerLink]="['/contact-us']"
                                class="sm:font-normal font-medium sm:text-base text-sm leading-5 sm:tracking-normal tracking-[-0.09px] hover:text-white cursor-pointer">
                              Contact Us
                            </a>
                        </li>
                    </ul>
  </div>

  <!--4th  = 2 cols -->
  <div class="xl:col-span-2 col-span-6">
     <ul class="xl:space-y-3  space-y-2.5">
                        <li>
                            <a [routerLink]="['/standard-commercial-license']"
                                class="sm:font-normal font-medium sm:text-base text-sm leading-5 sm:tracking-normal tracking-[-0.09px] hover:text-white cursor-pointer">
                                Standard Commercial License
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/personal-use-license']"
                                class="sm:font-normal font-medium sm:text-base text-sm leading-5 sm:tracking-normal tracking-[-0.09px] hover:text-white cursor-pointer">
                                Personal Use License 
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/refund-policy']"
                                class="sm:font-normal font-medium sm:text-base text-sm leading-5 sm:tracking-normal tracking-[-0.09px] hover:text-white cursor-pointer">
                                Payment Refund Policy
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/terms-of-use']"
                                class="sm:font-normal font-medium sm:text-base text-sm leading-5 sm:tracking-normal tracking-[-0.09px] hover:text-white cursor-pointer">
                            Terms of Use
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/privacy-policy']"
                                class="sm:font-normal font-medium sm:text-base text-sm leading-5 sm:tracking-normal tracking-[-0.09px] hover:text-white cursor-pointer">
                            Privacy Policy
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/cookie-policy']"
                                class="sm:font-normal font-medium sm:text-base text-sm leading-5 sm:tracking-normal tracking-[-0.09px] hover:text-white cursor-pointer">
                           Cookie Policy
                            </a>
                        </li>
                    </ul>
  </div>

  <!--5th  = 2 cols -->
  <div class="xl:col-span-2 col-span-6">
         <ul class="xl:space-y-3  space-y-2.5">
                            <li>
                                <p class="sm:font-normal font-medium sm:text-base text-sm leading-5 sm:tracking-normal tracking-[-0.09px] text-[#F0F0F0] whitespace-nowrap">
                                    Get in touch
                                </p>
                            </li>
                            <li>
                                <p class="font-semibold text-sm leading-5 tracking-[-0.09px] text-[#878787]">
                                    Stay updated with our latest news and products
                                </p>
                            </li>
                            <!-- Social Icons -->
                            <li>
                                <div class="flex gap-2 mt-2">
                                    <a href="https://dribbble.com/creativestall" target="_blank" rel="noopener noreferrer"
                                        aria-label="Creative Stall on Dribbble"
                                        class="w-8 h-8 rounded-xl bg-[#FFFFFF0D] border border-[#FFFFFF1A] flex items-center justify-center">
                                        <img src="../../../../../assets/images/dribble-footer-icon.svg" alt="Creative Stall on Dribble" aria-hidden="true">
                                    </a>
                                    <a href="https://www.behance.net/creativestall" target="_blank" rel="noopener noreferrer"
                                        aria-label="Creative Stall on Behance"
                                        class="w-8 h-8 rounded-xl bg-[#FFFFFF0D] border border-[#FFFFFF1A] flex items-center justify-center">
                                        <img src="../../../../../assets/images/behance-footer-icon.svg" alt="Creative Stall on Behance" aria-hidden="true">
                                    </a>
                                    <a href="https://www.instagram.com/creative.stall/" target="_blank" rel="noopener noreferrer"
                                        aria-label="Creative Stall on Instagram"
                                        class="w-8 h-8 rounded-xl bg-[#FFFFFF0D] border border-[#FFFFFF1A] flex items-center justify-center">
                                        <img src="../../../../../assets/images/instagram-footer-icon.svg" alt="Creative Stall on Instagram" aria-hidden="true">
                                    </a>
                                </div>
                            </li>
                        </ul>
  </div>
  </div>
  <div class="grid grid-cols-12 xl:gap-x-4 gap-x-6 xl:gap-y-0 gap-y-[30px]">
  <!-- 6th = 10 cols -->
  <div class="xl:col-span-10 md:col-span-6 col-span-12">
 
                <p class="font-semibold text-sm text-[#878787] whitespace-nowrap">
                    © {{currentYear}} Brickclay LLC. All rights reserved
                </p>
           
  </div>
  <!-- 7th = 10 cols -->
  <div class="xl:col-span-2 md:col-span-6 col-span-12">
           <!-- Secure Payment Badge -->
                <div class="bg-[#FFFFFF0D] border border-[#FFFFFF1A] rounded-md px-3 py-2  inline-block pr-5">
                    <div class="flex items-center ">
                        <img src="../../../../../assets/theme/images/logo/secure-lock.svg" alt="secure lock">
                        <span class="text-xs leading-normal font-medium text-[#747474] ms-2 me-[14px]">Secure Payment</span>
                        <img src="../../../../../assets/theme/images/logo/stripe-logo.svg" width="66" height="28" alt="Stripe logo">
                    </div>
                </div>
  </div>
</div>
 
    </div>
</footer>
 